export default __webpack_public_path__ + "static/media/hawkerchans.137948ec.jpeg";